import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const ticketStaus = createAsyncThunk(
  "ticketStaus",
  async ({ id, status, message }, { rejectWithValue }) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const payload = { status, message };

      const response = await AxiosInstance.put(
        `${API_KEY}/api/help-desk/status/${id}`,
        payload,
        {
          headers: {
            Authorization: `Barear ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const initialState = {
  isLoading: false,
  ticketStausData: null,
  isError: false,
  errorMessage: "",
};
const ticketStausSlice = createSlice({
  name: "ticketStaus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ticketStaus.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(ticketStaus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ticketStausData = action.payload;
      })
      .addCase(ticketStaus.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload || action.error.message;
      });
  },
});

export default ticketStausSlice.reducer;
